import { Button, Chip, Paper, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, To } from "react-router";

type PlannerDraftStatusDrawerProps = {
    totalDrafts: number;
    openReviewPanelHref: To;
};

export function PlannerDraftStatusDrawer({ totalDrafts, openReviewPanelHref }: PlannerDraftStatusDrawerProps) {
    const { t } = useTranslation("plannerV2");

    return (
        <Stack
            component={Paper}
            justifyContent="space-between"
            direction="row"
            columnGap={2}
            sx={theme => ({
                padding: 2,
                backgroundColor: totalDrafts === 0 ? theme.palette.background.default : theme.palette.primary.dark,
            })}
        >
            <Chip
                color={totalDrafts === 0 ? "default" : "primary"}
                label={t("reviewPlanPanel.visitsDrafted", { count: totalDrafts })}
            />
            <Button component={Link} disabled={totalDrafts === 0} variant="contained" to={openReviewPanelHref}>
                {t("reviewPlanPanel.reviewAndPlanButton")}
            </Button>
        </Stack>
    );
}
